<template>
  <div class="assertion-set">
    <AssertionRow v-if="assertionIds.length" 
      :assertionId="assertionIds.at(0)" 
      :baseDate="baseDate"
      no-attrib
      :count="showCount ? assertionIds.length : undefined"
      :dimmed="allDimmedRef"
      @click="onClickTop"/>
    <div v-if="!isSingletonRef" ref="setMemberListRef" class="collapse">
      <ul class="list-unstyled">
        <li v-for="id in assertionIds" :key="id">
          <AssertionRow 
            :assertionId="id"
            :baseDate="baseDate"
            no-icon
            indented
            :dimmed="dimmedIds?.includes(id)"
            @click="onClickOne"/>
        </li>
      </ul>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.assertion-set {
  border-bottom: 1px solid #edeff0;
  padding: 0 0.5rem;
  padding-bottom: 2px;

  ul {
    padding: 0.5rem 0;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }
}
</style>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { FuzzyDate } from '@/rd/FuzzyDate'
import { Collapse } from 'bootstrap'
import AssertionRow from './AssertionRow.vue'

const props = defineProps<{
  assertionIds: string[]
  baseDate: FuzzyDate | undefined
  dimmedIds?: string[]
  showCount?: boolean
}>()

const emit = defineEmits([
  "click",
])

const setMemberListRef = ref<HTMLUListElement>()

const isSingletonRef = computed(() => props.assertionIds.length === 1)
const allDimmedRef = computed(() => {
  return props.dimmedIds && props.assertionIds.every(id => props.dimmedIds!.includes(id))
})

function onClickTop(id: string) {
  if (isSingletonRef.value) {
    onClickOne(id)
  }
  else if (setMemberListRef.value) {
    new Collapse(setMemberListRef.value).toggle() // toggles the collapse state
  }
}

function onClickOne(id: string) {
  emit('click', id)
}
</script>
